
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { equals, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { WarningAlertContent } from "../Components/Alert.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton as singleton_1, map as map_2, empty, isEmpty, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TextButton, Button } from "../Components/Button.js";
import { Msg } from "./Types.js";
import { TextValue, BlockHeader } from "../Components/Text.js";
import { MultiSelect } from "../Components/Select.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { LanguageSelector } from "../Components/I18n.js";
import { isNeeded, Permission } from "../WebPush.js";
import { NewsletterConsent, UserNotificationSettings } from "../Widgets/NotificationSettings.js";
import { Skeleton } from "../Components/Skeleton.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";

function profileBox(children) {
    return reactElement("div", {
        className: join(" ", ["bg-white", "rounded", "px-12", "py-9"]),
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function permissionKey(permission) {
    switch (permission.tag) {
        case 1:
            return "default";
        case 2:
            return "denied";
        case 3:
            return "granted";
        default:
            return "unsupported";
    }
}

function BrowserPushPermissionWarning(props) {
    let elems_2;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", "browser-push-permission-warning"], ["data-permission", permissionKey(props.Permission)], (elems_2 = toList(delay(() => {
        let elems;
        return append(singleton(createElement(WarningAlertContent, {
            Content: reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems = toList(delay(() => append(singleton(reactElement("div", {
                children: t("notification_settings.browser_push.permission_missing"),
            })), delay(() => {
                const matchValue = props.Permission;
                switch (matchValue.tag) {
                    case 2:
                        return singleton(reactElement("div", {
                            children: t("notification_settings.browser_push.denied_hint"),
                        }));
                    case 1:
                    case 3:
                        return singleton(defaultOf());
                    default:
                        return singleton(reactElement("div", {
                            children: t("notification_settings.browser_push.unsupported"),
                        }));
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))),
        })), delay(() => {
            let elems_1;
            const matchValue_1 = props.Permission;
            switch (matchValue_1.tag) {
                case 1:
                case 2:
                case 3:
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-3"])], (elems_1 = [createElement(Button, {
                        ComponentState: props.ComponentState,
                        Label: t("notification_settings.browser_push.request_permission"),
                        OnClick: () => {
                            props.Dispatch(new Msg(7, []));
                        },
                        TestId: "browser-push-request-permission",
                        Variant: "secondary",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                default:
                    return singleton(defaultOf());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function DashboardSettings(props) {
    let elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const toOption = (viewName) => ({
        label: viewName,
        value: viewName,
    });
    return profileBox(ofArray([createElement(BlockHeader, {
        Text: t("profile.dashboard_header"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = toList(delay(() => (isEmpty(props.SavedViews) ? singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("dashboard.availability_no_views_hint"),
    })) : append(singleton(createElement(MultiSelect, {
        ComponentState: componentState,
        IsClearable: true,
        Label: t("dashboard.availability_select_views"),
        NoOptionsMessage: "dashboard.availability_no_views",
        OnChange: (options) => {
            props.Dispatch(new Msg(17, [defaultArg(map((options_1) => ofArray(map_1((_arg) => _arg.value, options_1)), options), empty())]));
        },
        Options: map_2((view) => toOption(view.Name), props.SavedViews),
        PlaceholderKey: "dashboard.availability_select_views",
        TestId: "profile-dashboard-view-select-test-id",
        Value: map_2(toOption, props.DashboardViewNames),
    })), delay(() => {
        let children;
        return singleton((children = singleton_1(createElement(Button, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                props.Dispatch(new Msg(18, []));
            },
            TestId: "profile-dashboard-save-button",
            Variant: "primary",
        })), reactElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        })));
    }))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))]));
}

export function ViewContent(props) {
    let elems_5, elems, elems_1, elems_4, elems_3, matchValue_5;
    const t = useTranslation()[0];
    const componentState = (props.State.NotificationSettings.tag === 0) ? "disabled" : (!props.State.NotificationFormState.IsLoading ? "enabled" : "disabled");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid grid-cols-2 gap-4", "items-start"])], (elems_5 = [profileBox(ofArray([createElement(BlockHeader, {
        Text: t("profile.password_header"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("profile.password_reset_description_1"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("profile.password_reset_description_2"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-2"])], (elems = [createElement(TextButton, {
        ComponentState: props.State.PasswordFormState.IsLoading ? "disabled" : "enabled",
        Label: t("profile.reset_password"),
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "profile-resetpassword-button",
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))])), profileBox(ofArray([createElement(BlockHeader, {
        Text: t("profile.language_header"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["w-64"])], (elems_1 = [createElement(LanguageSelector, {
        ChangeCallback: (arg) => {
            props.Dispatch(new Msg(1, [arg]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))])), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_4 = [profileBox(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_3 = toList(delay(() => append(singleton(createElement(BlockHeader, {
        Text: t("notification_settings.title"),
    })), delay(() => {
        let matchValue_1, settings, matchValue_2, matchValue_3;
        return append((matchValue_1 = props.State.NotificationSettings, (matchValue_1.tag === 1) ? ((settings = matchValue_1.fields[0], append((matchValue_2 = props.State.WebPushConfiguration, (matchValue_3 = props.State.WebPushPermission, (matchValue_2.tag === 1) ? ((matchValue_2.fields[0].Configuration != null) ? ((!equals(matchValue_3, new Permission(3, [])) && isNeeded(settings.Cells)) ? singleton(createElement(BrowserPushPermissionWarning, {
            ComponentState: props.State.WebPushFormState.IsLoading ? "disabled" : "enabled",
            Dispatch: props.Dispatch,
            Permission: matchValue_3,
        })) : singleton(defaultOf())) : singleton(defaultOf())) : singleton(defaultOf()))), delay(() => singleton(createElement(UserNotificationSettings, {
            ComponentState: componentState,
            OnToggle: (cells, enabled) => {
                props.Dispatch(new Msg(5, [cells, enabled]));
            },
            Settings: settings,
        })))))) : singleton(createElement(Skeleton, {
            Variant: "normal",
        }))), delay(() => append(singleton(createElement(NewsletterConsent, {
            FormState: componentState,
            OnChangeNewsletterConsent: (arg_1) => {
                props.Dispatch(new Msg(10, [arg_1]));
            },
            User: props.User,
        })), delay(() => {
            let elems_2;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_2 = [createElement(Button, {
                ComponentState: componentState,
                Label: t("general.save"),
                OnClick: () => {
                    props.Dispatch(new Msg(12, []));
                },
                TestId: "update-notification-settings-button",
                Variant: "primary",
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))), createElement(DashboardSettings, {
        DashboardViewNames: props.State.DashboardViewNames,
        Dispatch: props.Dispatch,
        FormState: props.State.DashboardFormState,
        SavedViews: (matchValue_5 = props.State.SavedAvailabilityViews, (matchValue_5.tag === 1) ? empty() : matchValue_5.fields[0]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function ProfileView(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.TokenDataDto, undefined);
    const state_1 = patternInput[0];
    return reactElement("div", createObj(singleton_1((elems = toList(delay(() => {
        const matchValue = state_1.User;
        const matchValue_1 = state_1.Storages;
        let matchResult, user;
        if (matchValue.tag === 1) {
            if (matchValue_1.tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 0;
            }
        }
        else if (matchValue_1.tag === 0) {
            matchResult = 1;
            user = matchValue.fields[0];
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0:
                return singleton(createElement(Skeleton, {
                    Variant: "normal",
                }));
            default:
                return singleton(createElement(ViewContent, {
                    Dispatch: patternInput[1],
                    State: state_1,
                    User: user,
                }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

